import React, { useState, useEffect, useRef } from "react";

const words = [
  { text: "business", color: "#F18D50" },
  { text: "organization", color: "#3B82F6" },
  { text: "non-profit", color: "#10B981" },
  { text: "app", color: "#8B5CF6" },
  { text: "website", color: "#EF4444" },
];

const TYPO_CHARS = "qwertyuiopasdfghjklzxcvbnm";
const randomChar = () => TYPO_CHARS[Math.floor(Math.random() * TYPO_CHARS.length)];

// Build the keystroke sequence for a word, injecting 1-2 typos
function buildSteps(word) {
  const steps = [];
  let typed = "";
  const typoCount = 1 + Math.floor(Math.random() * 2);
  const typoPositions = new Set();
  while (typoPositions.size < typoCount && word.length > 2) {
    typoPositions.add(1 + Math.floor(Math.random() * (word.length - 1)));
  }
  for (let i = 0; i < word.length; i++) {
    if (typoPositions.has(i)) {
      // type 1-2 wrong letters, then delete them
      const wrongCount = 1 + Math.floor(Math.random() * 2);
      let wrong = typed;
      for (let w = 0; w < wrongCount; w++) {
        wrong += randomChar();
        steps.push({ text: wrong, delay: 90 + Math.random() * 80 });
      }
      // brief "oops" pause, then backspace
      for (let w = 0; w < wrongCount; w++) {
        wrong = wrong.slice(0, -1);
        steps.push({ text: wrong, delay: w === 0 ? 320 : 70 });
      }
    }
    typed += word[i];
    steps.push({ text: typed, delay: 70 + Math.random() * 90 });
  }
  // hold the finished word
  steps.push({ text: typed, delay: 1600 });
  // delete it quickly
  while (typed.length > 0) {
    typed = typed.slice(0, -1);
    steps.push({ text: typed, delay: 35 });
  }
  return steps;
}

export default function RotatingWord() {
  const [display, setDisplay] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const steps = buildSteps(words[wordIndex].text);
    let i = 0;

    const run = () => {
      if (i >= steps.length) {
        setWordIndex((w) => (w + 1) % words.length);
        return;
      }
      const step = steps[i++];
      setDisplay(step.text);
      timerRef.current = setTimeout(run, step.delay);
    };

    timerRef.current = setTimeout(run, 300);
    return () => clearTimeout(timerRef.current);
  }, [wordIndex]);

  return (
    <span className="inline-flex items-baseline whitespace-nowrap">
      <span style={{ color: words[wordIndex].color }}>{display}</span>
      <span
        className="inline-block w-[3px] h-[0.9em] ml-0.5 translate-y-[0.1em] animate-pulse"
        style={{ backgroundColor: words[wordIndex].color }}
      />
    </span>
  );
}